import { render, staticRenderFns } from "./WBtnDelete.vue?vue&type=template&id=ed2e0c58&scoped=true&"
import script from "./WBtnDelete.vue?vue&type=script&lang=js&"
export * from "./WBtnDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2e0c58",
  null
  
)

export default component.exports